// extracted by mini-css-extract-plugin
export default {"contactSubtitle":"ContactPerson_contactSubtitle__JcRQr","contactText":"ContactPerson_contactText__EJfOQ"};